/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2020-09-09 14:38:05
 * @LastEditors: Ning
 * @Description: System Logs 日志
 * @Do not edit
 */

import Home from "../pages/Home";
 let routers = [
    {path:"/", name:"home", component:Home, title:'公告',views:true},
    // {path:"/home:myParams", name:"home", component:Home, title:'公租房',views:true},
]

export default routers
